import React from 'react';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import { FiArrowUp } from 'react-icons/fi';
import {
  FooterContainer,
  Inner,
  Top,
  Brand,
  Links,
  FLink,
  Socials,
  SocialIconLink,
  Bottom,
  Rights,
  ToTop,
} from './Footer.elements';

const NAV = [
  { to: 'about', label: 'About' },
  { to: 'skills', label: 'Skills' },
  { to: 'experience', label: 'Experience' },
  { to: 'projects', label: 'Projects' },
  { to: 'certifications', label: 'Certifications' },
  { to: 'gallery', label: 'Gallery' },
  { to: 'contact', label: 'Contact' },
];

function Footer() {
  return (
    <FooterContainer>
      <Inner>
        <Top>
          <Brand>
            <h3>
              EnesG. <span className="dot" />
            </h3>
            <p>
              Fullstack Product Engineer building web & mobile products from
              zero to production with a product-first mindset.
            </p>
          </Brand>

          <Links>
            {NAV.map((n) => (
              <FLink
                key={n.to}
                to={n.to}
                smooth
                duration={500}
                spy
                exact="true"
                offset={-70}
              >
                {n.label}
              </FLink>
            ))}
          </Links>

          <Socials>
            <SocialIconLink
              href="https://github.com/CodderEnesG"
              target="_blank"
              rel="noreferrer"
              aria-label="GitHub"
            >
              <FaGithub />
            </SocialIconLink>
            <SocialIconLink
              href="https://www.linkedin.com/in/enes-g%C3%BCng%C3%B6r-658895205/"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedin />
            </SocialIconLink>
            <SocialIconLink
              href="mailto:enesgungor.gs@gmail.com"
              aria-label="Email"
            >
              <FaEnvelope />
            </SocialIconLink>
          </Socials>
        </Top>

        <Bottom>
          <Rights>
            © {new Date().getFullYear()} Enes Güngör. All rights reserved.
          </Rights>
          <ToTop to="home" smooth duration={500} offset={-80}>
            Back to top <FiArrowUp />
          </ToTop>
        </Bottom>
      </Inner>
    </FooterContainer>
  );
}

export default Footer;
